"use client";

// Bundles the dead-click detector so posthog-js never loads it as a script
// (a late script could otherwise start it on whatever page is showing).
import { c as _c } from "react/compiler-runtime";
import "posthog-js/dist/dead-clicks-autocapture";
import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { isMarketingPath } from "@/lib/marketing-routes";
import { setMarketingRoute } from "@/lib/posthog-click-capture";

// Rage and dead click capture for public marketing pages. Mounted only by the
// (site) layout; the upload layout never runs it.
export default function PostHogClickCapture() {
  const $ = _c(3);
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname) {
    t0 = [pathname];
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useEffect(_temp, t0);
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useEffect(_temp3, t1);
  return null;
}
function _temp3() {
  return _temp2;
}
function _temp2() {
  return setMarketingRoute(false);
}
function _temp() {
  setMarketingRoute(isMarketingPath(window.location.pathname));
}